'use strict';

app.controller('ServiceCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$ngConfirm',
    'toaster',
    function($scope, $http, $translate, $ngConfirm, toaster) {
        $scope.SERVICE_TAB = 1;
        $scope.VEHICLES_TAB = 2;

        $scope.tab = $scope.VEHICLES_TAB;
        $scope.loading = false;
        $scope.form = false;
        $scope.vehicleForm = false;

        $scope.types = [];
        $scope.services = [];
        $scope.pagination = {
            current: 1
        };

        $scope.options = {
            types: [
                'dates',
                'worktime',
                'distance',
                // 'odometer',
                'gps',
            ],
            objects: [],
        };
        $scope.selected = {
            type: {
                type: $scope.options.types[0],
                code: '',
                name: '',
            },
            service: {
                args: {},
            },
        };
        $scope.initial = angular.copy($scope.selected);

        $scope.changeTab = function(v) {
            $scope.form = false;
            $scope.tab = v;
        };
        $scope.isServiceTab = function() {
            return $scope.tab == $scope.SERVICE_TAB;
        };
        $scope.isVehiclesTab = function() {
            return $scope.tab == $scope.VEHICLES_TAB;
        };
        $scope.toggleForm = function() {
            $scope.form = !$scope.form;
        };
        $scope.isVisibleForm = function() {
            return $scope.form;
        };

        var getVehicleOdometer = function(id) {
            return $http.get('/api/node/object/odometer', { params: { object: id } }).then(function(response) {
                var distance = ((response.data || {}).data || {}).Value;
                return distance !== void 0 ? distance : 0;
            });
        }

        $scope.toggleVehicleForm = function(id) {
            $scope.vehicleForm = $scope.vehicleForm === id ? false : id;
            $scope.resetVehicleForm(true, id);
        };
        $scope.isVisibleVehicleForm = function(id) {
            return $scope.vehicleForm === id;
        };
        $scope.deleteServiceType = function(id) {
            $http.post('/api/service/deleteType/', { id: id }).then(function() {
                $scope.getTypes();
                $scope.getServices($scope.pagination.current);
            });
        };
        $scope.deleteService = function(id) {
            $http.post('/api/service/delete/', { id: id }).then(function() {
                $scope.getServices($scope.pagination.current);
            });
        };
        $scope.saveServiceType = function(obj) {
            var payload = obj ? obj : $scope.selected.type;

            $http.post('/api/service/type', payload).then(function() {
                $scope.getTypes();
                $scope.selected.type = angular.copy($scope.initial.type);
            });
        };
        $scope.resetVehicleForm = function(bool, id) {
            $scope.selected.service.args = {};

            if ($scope.types.length && bool) {
                $scope.selected.service.type = $scope.types[0];
            }

            var service = ($scope.selected.service.type || {}).type || {};
            if ($scope.vehicleForm && service !== void 0 && service === 'distance') {
                var i = $scope.services.findIndex(function(o) {
                    return o.id === id;
                });

                $scope.selected.service.args.made = 0;
                if (i >= 0) {
                    getVehicleOdometer(id).then(function(distance) {
                        $scope.selected.service.args.made = distance;
                    })
                }
            }
        };
        $scope.getTypes = function() {
            $scope.loading = true;
            $http.get('/api/service/types').then(
                function(response) {
                    $scope.types =
                        typeof response.data.data !== 'undefined'
                            ? response.data.data
                            : [];
                    $scope.resetVehicleForm(true);
                    $scope.loading = false;
                },
                function() {
                    $scope.loading = false;
                }
            );
        };

        $scope.go = function(page) {
            $scope.getServices(page);
        }

        $scope.getServices = function(page) {
            $scope.loading = true;

            var params = {
                page: page
            };

            if ($scope.app.group.id > 0) {
                params.group = $scope.app.group.id;
            }

            $http.get('/api/service/list', {
                params: params
            }).then(
                function(response) {
                    var result = response.data.data;

                    $scope.services = result.results;
                    $scope.pagination = result.pagination;

                    $scope.prepareServices();
                    $scope.loading = false;
                },
                function() {
                    $scope.loading = false;
                }
            );
        };
        $scope.prepareServices = function() {
            for (var i in $scope.services) {
                var service = $scope.services[i];
                for (var j in service.services) {
                    var single = service.services[j];

                    ['made', 'remind', 'next'].map(function(item) {
                        switch (single.type.type) {
                            case 'dates':
                                $scope.services[i].services[j].args[
                                    item
                                ] = moment(
                                    $scope.services[i].services[j].args[item]
                                );
                                break;
                        }
                    });
                    switch (single.type.type) {
                        case 'worktime':
                            $scope.services[i].services[j].args.made = moment(
                                $scope.services[i].services[j].args.made
                            );
                            break;
                    }
                }
            }
        };
        $scope.beforeSaveService = function(payload) {
            var args = {};
            ['made', 'remind', 'next'].map(function(item) {
                switch (payload.type.type) {
                    case 'dates':
                        var time =
                            item === 'remind'
                                ? payload.args[item].startOf('day')
                                : payload.args[item].endOf('day');
                        args[item] = time.format('YYYY-MM-DD HH:mm:ss');
                        break;
                    case 'distance':
                    case 'odometer':
                    case 'gps':
                        args[item] = parseFloat(payload.args[item]);
                        break;
                }
            });
            switch (payload.type.type) {
                case 'worktime':
                    args.made = payload.args.made.format('YYYY-MM-DD HH:mm:ss');
                    args.remind = parseFloat(payload.args.remind);
                    args.next = parseFloat(payload.args.next);
                    break;
            }

            return args;
        };
        $scope.extendService = function(confirm) {
            $http
                .post('/api/service/extend/', { confirm: confirm })
                .then(function() {
                    $scope.getServices($scope.pagination.current);
                });
        };

        $scope.ngConfirmService = {};
        $scope.extendServiceModal = function(service) {
            $scope.ngConfirmService = {
                service: service,
                date: moment(),
                type: 2,
                times: 1,
            };

            $ngConfirm({
                title: $translate.instant('service.extend.header'),
                contentUrl: 'tpl/pages/service/modals/extend.html',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-date pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.ok'),
                        btnClass: 'btn-info',
                        action: function(scope) {
                            $scope.extendService($scope.ngConfirmService);
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };

        $scope.editModeEntry = false;
        $scope.isInEditMode = function(single) {
            return $scope.editModeEntry.id === single.id;
        };
        $scope.goToEditMode = function(single) {
            $scope.editModeEntry = single;
        };
        $scope.cancelEditMode = function() {
            $scope.editModeEntry = false;
        };
        $scope.validate = function(payload) {
            if (
                !payload.args.made ||
                !payload.args.remind ||
                !payload.args.next
            ) {
                return 'fillup';
            }

            if (
                payload.type.type === 'dates' &&
                !(
                    payload.args.made.isBefore(payload.args.remind, 'day') &&
                    payload.args.remind.isBefore(payload.args.next, 'day')
                )
            ) {
                return 'dates';
            }
            if (
                payload.type.type === 'distance' &&
                !(
                    payload.args.made < payload.args.remind &&
                    payload.args.remind < payload.args.next
                )
            ) {
                return 'distance';
            }
            if (payload.type.type === 'gps' && !(payload.args.remind < payload.args.next)) {
                return 'gps';
            }
            return true;
        };
        $scope.saveService = function(object, id, obj) {
            var payload = obj ? obj : $scope.selected.service;
            var validation = $scope.validate(payload);
            if (validation !== true) {
                toaster.pop(
                    'error',
                    $translate.instant('service.toastr.error.header'),
                    $translate.instant('service.toastr.error.' + validation)
                );
                return false;
            }

            var args = $scope.beforeSaveService(payload);
            var data = {
                id: id,
                object_id: object,
                service_type_id: payload.type.id,
                args: args,
            };
            $scope.cancelEditMode();

            $http.post('/api/service/save', data).then(function() {
                $scope.getServices($scope.pagination.current);
                $scope.resetVehicleForm(true, object);
            });
        };
        $scope.init = function() {
            $scope.getTypes();
            $scope.getServices($scope.pagination.current);
        };
        $scope.init();
    },
]);
